export var DESKTOP_BREAKPOINT = 1232;
export var MOBILE_BREAKPOINT = 616;
export var TOP_NAV_HEIGHT = 64;
export var LEFT_NAV_WIDTH = 256;
export var MOBILE_MEDIA_QUERY = "@media (max-width: ".concat(MOBILE_BREAKPOINT - 1, "px)");
export var NON_MOBILE_MEDIA_QUERY = "@media (min-width: ".concat(MOBILE_BREAKPOINT, "px)");
export var TABLET_MEDIA_QUERY = "@media (max-width: ".concat(DESKTOP_BREAKPOINT - 1, "px)");
export var DESKTOP_MEDIA_QUERY = "@media (min-width: ".concat(DESKTOP_BREAKPOINT, "px)");
export var LEFT_BAR_EXPANDED_WIDTH = LEFT_NAV_WIDTH;
export var LEFT_BAR_COLLAPSED_WIDTH = 56;
export var LEFT_BAR_SPINE_WIDTH = 68;
export var ANIMATION_DURATION_MS = 240;
export var ContentGutter = {
    DESKTOP: 48,
    MOBILE: 24
};
// Provides a way to adjust legacy breakpoints upward to account for added
// left-nav and gutter width.
export var BREAKPOINT_ADJUSTMENT = LEFT_BAR_SPINE_WIDTH + ContentGutter.DESKTOP * 2;
export var withDesktopContentGutter = "\n  padding-right: ".concat(ContentGutter.DESKTOP, "px;\n  padding-left: ").concat(ContentGutter.DESKTOP, "px;\n\n  @media (max-width: ").concat(MOBILE_BREAKPOINT, "px) {\n    padding-left: 0;\n    padding-right: 0;\n  }\n");
export var withMobileContentGutter = "\n  @media (max-width: ".concat(MOBILE_BREAKPOINT, "px) {\n    padding-right: ").concat(ContentGutter.MOBILE, "px;\n    padding-left: ").concat(ContentGutter.MOBILE, "px;\n  }\n");
/**
 * Usage:
 * const Container = styled.div`
 *   ${withContentGutter}
 * `;
 */ export var withContentGutter = "\n  padding-right: ".concat(ContentGutter.DESKTOP, "px;\n  padding-left: ").concat(ContentGutter.DESKTOP, "px;\n\n  @media (max-width: ").concat(MOBILE_BREAKPOINT, "px) {\n    padding-right: ").concat(ContentGutter.MOBILE, "px;\n    padding-left: ").concat(ContentGutter.MOBILE, "px;\n  }\n");
